<h2 mat-dialog-title class="dialog-header">
    {{ "progressWindow.txtTitle" | translate }}
 </h2>
 <mat-dialog-content style="text-align: center;">
     <div class="block-icon">
        <svg xmlns="http://www.w3.org/2000/svg" height="64px" viewBox="0 -960 960 960" width="64px" fill="#5f6368">
          <path d="M500-560ZM200-120v-680h250q-5 20-8 40t-2 40H280v240h290l16 80h134v-46q20 0 40-3t40-9v138H520l-16-80H280v280h-80Zm491-516 139-138-42-42-97 95-39-39-42 43 81 81Zm29-290q83 0 141.5 58.5T920-726q0 83-58.5 141.5T720-526q-83 0-141.5-58.5T520-726q0-83 58.5-141.5T720-926Z"/>
        </svg>
     </div>
     <div class="block-descriptions">
        <div class="d-flex justify-content-start align-items-center gap-2" >
            <span class="number-title">ID</span>
            <div class="d-flex justify-content-start align-items-center gap-1 header-icon">
              {{ "progressWindow.txtTIcon" | translate }}
            </div>
            <span class="header-name">{{ "progressWindow.txtTName" | translate }}</span>
            @if(countLevel >= 1){
              <span class="header-level">1 *</span>
            }
            @if(countLevel >= 2){
              <span class="header-level">2 *</span>
            }
            @if(countLevel >= 3){
              <span class="header-level">3 *</span>
            }
            @if(countLevel >= 4){
              <span class="header-level">4 *</span>
            }            
        </div>
        @for (field of data.playField; track field.position) {
          <div class="d-flex justify-content-start align-items-center gap-2" >
            <span class="number-in-order">№{{ field.position }}</span>
            <div class="d-flex justify-content-start align-items-center gap-1 wpx-70">
              @for (icon of field.icons; track $index) {
                <span class="material-symbols-outlined fs-30">
                  {{ icon }}
                </span>
              }
            </div>
            <span class="content-name">{{ field.title }}</span>
            @if(countLevel >= 1){
              <span class="wpx-40">{{academicPerformance(field.position,1)}}</span>
            }
            @if(countLevel >= 2){
              <span class="wpx-40">{{academicPerformance(field.position,2)}}</span>
            }
            @if(countLevel >= 3){
              <span class="wpx-40">{{academicPerformance(field.position,3)}}</span>
            }
            @if(countLevel >= 4){
              <span class="wpx-40">{{academicPerformance(field.position,4)}}</span>
            }         
          </div>
        }
     </div>
 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick()">
             <span class="material-symbols-outlined">
                check_circle
             </span>
             <span>{{ 'buttons.txtContinue' | translate }}</span>
         </button>
     </div>       
   </mat-dialog-actions>